const Controller = require("./Controller");
const Utils = require("./Utils");

/**
 * @abstract
 * @class
 * @extends {Controller}
 */
function AbstractResourceController() {
    Controller.call(this);

    const self = this;
    let resourcesView;

    this.getId = function() {
        return "AbstractResourceController";
    };

    this.getResourcesView = function() {
        return resourcesView;
    };

    this.setResourcesView = function(view) {
        resourcesView = view;
    };

    $(document).on("resourceslistchange", function(event, resources) {
        if (resourcesView) {
            let filteredResources = self.filterResources(resources);
            resourcesView.renderListview(filteredResources);
        }
    });

    /**
     * @param {Object.<String, ResourcesModel~ResourceItem>} resources
     * @return {Object.<String, ResourcesModel~ResourceItem>}
     */
    this.filterResources = function(resources) {
        let hasNonLaunchables = false;
        let myItems = Utils.objectFilter(resources, function(resource) {
            let supportedType = self.getResourceTypes().indexOf(resource.type) !== -1;
            let launchable = !resource.hasOwnProperty("launchable") || resource.launchable === true;

            if (!launchable) {
                hasNonLaunchables = true;
            }
            return supportedType && launchable;
        }) || {};

        self.toggleTabVisibility(myItems, hasNonLaunchables);
        return myItems;
    };

    this.toggleTabVisibility = function(resources) {
        resourcesView.getContent().toggleClass("hidden-tab", Object.keys(resources).length === 0);
    };

    /**
     * @abstract
     * @return {Array.<string>}
     */
    this.getResourceTypes = function() {
        return [];
    };

    /**
     * @abstract
     */
    this.launchResource = function() {
        throw "Needs overriding";
    };

    function getLaunchCallback(id) {
        return function(launchToken, saveAttributes) {
            console.debug("Launch pre-requisites OK");

            // After updating the resource model reload this resource, as the launch url could have been updated from the attribute prompt
            const updateFunction = function() {
                let resourceItem = CudaLaunch.models.resources.getResource(id);
                console.debug("Resource updated with attribute values");
                self.launchResource(resourceItem, launchToken);
            };

            if (saveAttributes) {
                // If we're saving attributes update all resources as multiple resources can use the same attributes
                CudaLaunch.models.resources.refresh().then(updateFunction);
            } else {
                // Update just this resource in the resource model which will temporarily set launch attributes
                CudaLaunch.models.resources.updateResource(id).then(updateFunction);
            }
        };
    }

    /**
     * This resource could require a password that is not available
     * e.g. client restarted, server had a valid session so user did not have to authenticate, then launching a VPN connection,
     * client does not have the completed auth scheme value, so add to the attributes map to prompt for it.
     *
     * @param attributesMap
     * @param resourceItem
     * @returns {*} attributesMap (possibly modified)
     */
    function checkPasswordPrerequisite(attributesMap, resourceItem) {
        if (resourceItem.password !== undefined) {
            const session = CudaLaunch.serverConfiguration.getSession();
            let passwordAttribute = {
                value : "",
                format : 4
            };

            if (resourceItem.password === "" || resourceItem.password === "${session:password}") {
                if ((session.password === undefined || session.password === "") && !session.completedAuthSchemes[CudaLaunch.serverConfiguration.identity]) {
                    passwordAttribute.id = CudaLaunch.serverConfiguration.identity;
                }
            } else {
                const regex = /\${session:([^}]+)}/;
                let key = regex.exec(resourceItem.password);

                if (key && key[1] && key[1] !== "") {
                    if (!session.completedAuthSchemes[key[1]]) {
                        passwordAttribute.id = key[1];
                    }
                }
            }

            if (passwordAttribute.id) {
                if ($.isEmptyObject(attributesMap) || !attributesMap.session) {
                    attributesMap["session"] = [passwordAttribute];
                } else if (!attributesMap.session.find(function(attribute) {
                    return attribute.id === passwordAttribute.id;
                })) {
                    attributesMap.session.push(passwordAttribute);
                }
            }
        }
        return attributesMap;
    }

    this.isAllowedToLaunch = function(resource) {
        return !resource.dynamic || resource.dyn_state !== "Disabled";
    };

    /**
     * Determine if we have everything needed to launch this resource
     * And launch it if we do.
     *
     * @param {string} [id] the id of the resource
     */
    this.checkForPrerequisites = function(id) {
        const resourceItem = CudaLaunch.models.resources.getResource(id);
        const deferred = $.Deferred();

        // Attributes aren't supported on resources other than web forwards on servers earlier than 7.0.0,
        // And the endpoint changed on a 7.0.0 server
        // so don't try and check for them because it will just return an error
        let newEndpoint = Utils.isGreaterThanOrEqualToServerVersion(CudaLaunch.serverConfiguration.version, "7.0.0");
        let url = "/sslvpn_api/launchPrerequisites/webForward";

        if (newEndpoint) {
            url = "/sslvpn_api/launchPrerequisites";
        }

        if (newEndpoint || resourceItem.type === "web_forward") {
            $.ajax({
                url : url,
                type : "GET",
                data : {
                    resourceId : resourceItem.id
                },
                cache : false
            }).done(function(prerequisites) {
                let attributesMap = {};

                if (Array.isArray(prerequisites.attributes)) {
                    if (prerequisites.attributes.length > 0) {
                        attributesMap["user"] = prerequisites.attributes; // For pre-7.1 servers wrap the response in a user namespace
                    }
                } else {
                    attributesMap = prerequisites.attributes;
                }

                attributesMap = checkPasswordPrerequisite(attributesMap, resourceItem);

                if (!$.isEmptyObject(attributesMap)) {
                    CudaLaunch.controllers.LaunchAttributesController.resolveAttributes(attributesMap, prerequisites.launchId, getLaunchCallback(id),
                        $.t("common::attributes.prompt.title"), true)
                        .done(function() {
                            CudaLaunch.models.attributes.loadAttributes();
                        })
                        .fail(function(message) {
                            console.debug("resource launch failed with message: " + message);

                            if (message) {
                                CudaLaunch.controllers.RootController.showErrorDialog(message, false, "#resourceList li[data-resource-id=" + id + "]");
                            }
                        });
                } else {
                    self.launchResource(resourceItem, prerequisites.launchToken);
                }
            }).fail(function(e) {
                if (e.responseJSON) {
                    let message;

                    if (e.responseJSON.code && e.responseJSON.attribute) {
                        message = $.t("common::" + e.responseJSON.code) + " \"" + e.responseJSON.attribute + "\"";
                    } else if (e.responseJSON.result === "ERROR_MSG" && e.responseJSON.msg) {
                        message = $.t("common::" + e.responseJSON.msg);
                    } else {
                        message = e.responseJSON.error;
                    }

                    console.log("resource launch failed with message: " + message);
                    CudaLaunch.controllers.RootController.showErrorDialog(message, false, "#resourceList li[data-resource-id=" + id + "]", CudaLaunch.models.resources.refresh);
                }
            }).always(function() {
                deferred.resolve();
            });
        } else {
            self.launchResource(resourceItem);
            deferred.resolve();
        }

        return deferred;
    };
}

Utils.inherits(AbstractResourceController, Controller);

module.exports = AbstractResourceController;


//////////////////
// WEBPACK FOOTER
// ./common/AbstractResourceController.js
// module id = 23
// module chunks = 3 4